import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from 'vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'

interface EMITS {
  (e: 'toggleSearchInput', active: boolean)
  (e: 'emitSearchString', searchString: string)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InputSearch',
  props: {
  mobileScreen: {
    type: Boolean,
    required: false
  },
  showSearchInput: {
    type: Boolean,
    required: false
  },
  placeholderText: {
    type: String,
    default: ''
  },
  clearInput: {
    type: Boolean,
    default: false
  }
},
  emits: ["toggleSearchInput", "emitSearchString"],
  setup(__props, { emit: __emit }) {

const props = __props
const { mobileScreen, showSearchInput, placeholderText, clearInput } = toRefs(props)
const emits = __emit
async function submitSearch(string: string) {
  if (string.length && !showSearchInput.value) {
    // Show the search overlay when typing after using keyboard tab to navigate to search field
    toggleSearchInput(true)
    await new Promise((resolve) => setTimeout(resolve, 200)) // Wait for the search input to be visible before emitting the search string
  }
  emits('emitSearchString', string)
}
function toggleSearchInput(active: boolean) {
  emits('toggleSearchInput', active)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search__input", {
      'search__input-expanded': _unref(showSearchInput)
    }])
  }, [
    (_unref(showSearchInput) && _unref(mobileScreen))
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 0,
          class: "search__toggle-collapse",
          "icon-left": require('@/design-system/assets/icons/Icon-Chevron-Left.svg'),
          size: "medium-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSearchInput(false)))
        }, null, 8, ["icon-left"]))
      : _createCommentVNode("", true),
    (_unref(showSearchInput) || !_unref(mobileScreen))
      ? (_openBlock(), _createBlock(TextFieldStandard, {
          key: 1,
          placeHolderText: _unref(placeholderText),
          "search-input": true,
          clearInput: _unref(clearInput),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSearchInput(true))),
          onEmitInput: _cache[2] || (_cache[2] = (v) => submitSearch(v.toString())),
          onEmitClearInput: _cache[3] || (_cache[3] = ($event: any) => (submitSearch('')))
        }, null, 8, ["placeHolderText", "clearInput"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})